export default __webpack_public_path__ + "static/media/ArrowDownFill.88adbbb5.svg";